import { Typography, TypographyProps, styled } from '@mui/material'
import { notProp } from '@portal/pkg-utils'

export interface DisableTypographyProps extends TypographyProps {
  disabled?: boolean
}

export const DisablableTypography = styled(Typography, {
  name: 'DisablableTypography',
  slot: 'Root',
  shouldForwardProp: notProp('disabled'),
})<DisableTypographyProps>(({ theme, disabled }) => ({
  ...(disabled ? { color: theme.palette.text.disabled } : {}),
}))
